import { supabase } from './supabase';
import { extractFunctionErrorMessage } from '../utils/supabaseFunctionError';

const FUNCTION_NAME = 'admin-solicitudes-encargado';
const GENERIC_ERROR = 'No se pudo completar la operación. Intenta nuevamente.';

async function invoke(body) {
  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, { body });
  if (error) {
    const message = await extractFunctionErrorMessage(error);
    return { ok: false, message: message || GENERIC_ERROR };
  }
  return { ok: true, data };
}

export async function listarSolicitudes(estado = 'PENDIENTE') {
  const result = await invoke({ accion: 'LISTAR', estado });
  if (!result.ok) return result;
  return { ok: true, solicitudes: result.data?.solicitudes ?? [] };
}

export async function obtenerDetalleSolicitud(solicitudId) {
  const result = await invoke({ accion: 'DETALLE', solicitud_id: Number(solicitudId) });
  if (!result.ok) return result;
  return { ok: true, solicitud: result.data?.solicitud ?? null };
}

export async function listarProductoresActivos() {
  const result = await invoke({ accion: 'PRODUCTORES' });
  if (!result.ok) return result;
  return { ok: true, productores: result.data?.productores ?? [] };
}

export async function aprobarSolicitud(solicitudId, productoresIds) {
  return invoke({
    accion: 'APROBAR',
    solicitud_id: Number(solicitudId),
    productores_ids: (productoresIds ?? []).map((id) => Number(id)),
  });
}

export async function rechazarSolicitud(solicitudId, motivo) {
  return invoke({ accion: 'RECHAZAR', solicitud_id: Number(solicitudId), motivo });
}
